export enum AccessRole {
  PLATFORM_USER = 'Platform User',
  ADMIN = 'Admin',
  SPEECHY_ADMIN = 'Speechy Admin',
  // Removed from now until this task is completed
  // https://app.asana.com/0/1207954996578868/1209160497840364
}

/**
 * Returns all user-assignable roles (excludes system roles like SPEECHY_ADMIN)
 */
export function getUserAssignableRoles(): AccessRole[] {
  return Object.values(AccessRole).filter(role => role !== AccessRole.SPEECHY_ADMIN);
}
